import { Outlet } from 'react-router';

import Card from '@/components/ui/card';
import { permissionLabel } from '@/lib/labels';

import { useSession } from './use-session';

/**
 * Gate for a screen that needs a specific permission.
 *
 * The nav already hides what an administrator cannot reach, so arriving here
 * means a typed URL or a stale link. It explains rather than redirecting —
 * bouncing someone to the dashboard reads like a bug.
 */
export default function RequirePermission({ permission }: { permission: string }) {
  const { can } = useSession();

  if (!can(permission)) {
    return (
      <Card title="Not available to your account">
        <p className="m-0 text-base text-ink-muted">
          Your account cannot {permissionLabel(permission)}. Ask a super administrator if you need
          to.
        </p>
      </Card>
    );
  }

  return <Outlet />;
}
